export default __webpack_public_path__ + "9511875ae1bae57a60c0fb9f540634e0.svg";